module.exports = __webpack_public_path__ + "img/chat-bubble.59cafedd.png";